import { clamp } from 'lodash-es';

/* eslint-disable-next-line no-restricted-imports -- This is necessary to use the root prop type
   definitions without introducing a circular dependency with Typography.tsx. */
import { type TypographyProps } from '@mui/material/Typography';

import type * as types from './types';

export interface TypographyTruncatedStyleProps extends Pick<
  TypographyProps,
  'display' | 'overflow' | 'textOverflow' | 'whiteSpace'
> {
  readonly lineClamp?: types.LineClamp;
  readonly truncate?: boolean;
}

interface TypographyTruncatedStyle extends Pick<
  TypographyProps,
  'display' | 'overflow' | 'textOverflow' | 'whiteSpace'
> {
  readonly WebkitBoxOrient?: 'vertical';
  readonly WebkitLineClamp?: number;
}

export const parseTypographyTruncatedStyle = ({
  lineClamp,
  truncate,
  ...props
}: TypographyTruncatedStyleProps): TypographyTruncatedStyle => {
  const parsedLineClamp =
    lineClamp !== undefined && lineClamp !== 'none' ? clamp(lineClamp, 1, 100) : undefined;

  return {
    display: props.display ?? (parsedLineClamp ? '-webkit-box' : undefined),
    overflow: props.overflow ?? (parsedLineClamp || truncate ? 'hidden' : undefined),
    textOverflow: props.textOverflow ?? (parsedLineClamp || truncate ? 'ellipsis' : undefined),
    WebkitBoxOrient: parsedLineClamp ? 'vertical' : undefined,
    WebkitLineClamp: parsedLineClamp,
    whiteSpace: props.whiteSpace ?? (truncate ? 'pre-wrap' : undefined),
  } as const;
};
